export default "__VITE_ASSET__7cbb9cfd__"